<template>
  <ActivationDetails
    :activation="activation"
    :context="context"
    :style="patchedDetailsStyle"
    class="sdv-embed-activation-details sdv-embed-component"
    v-on="listeners"
  >
    <template #header>
      <div class="sdv-embed-activation-details__header">
        <SdvBtn
          class="sdv-embed-activation-details__close-btn"
          :svg="mdiClose"
          round
          @click="$emit('close')"
        />
      </div>
    </template>
  </ActivationDetails>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi'
import { mdiClose } from '@mdi/js'
import SdvBtn from '../SdvBtn/SdvBtn.vue'
import { ActivationDetails, useBypassActivationListEvents, defineActivationListEmits } from '@source-digital/activation-list-vue'

export default defineComponent({
  name: 'SdvActivationDetails',
  components: {
    ActivationDetails,
    SdvBtn
  },
  props: {
    ...(ActivationDetails.props)
  },
  emits: {
    ...defineActivationListEmits()
  },
  setup (_props, context) {
    const listeners = useBypassActivationListEvents(context)
    return {
      mdiClose,
      listeners
    }
  }
})
</script>

<style lang="scss" src="./SdvActivationDetails.scss"></style>
